import { IPurchase } from './types';


export async function doFetchPurchase(
  apiUrl: string,
  purchaseId: number,
  token: string
): Promise<IPurchase | null> {
  try {
    const rawResponse = await fetch(
      `${apiUrl}/host-api/purchase/${purchaseId}?secret=${token}`,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (!rawResponse.ok) {
      throw new Error(`Request for purchase #${purchaseId} failed`);
    }

    const response = await rawResponse.json();

    return response as IPurchase;
  } catch {
    return null;
  }
}

export async function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}
